import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../baseQuery";

export const PorterAPI = createApi({
  reducerPath: "PorterAPI",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({   

    porterOrderAPI: builder.mutation({
      query: (params) => ({
        url: `/api/seller/order/assign_porter_vehicle/`,
        method: "POST",
        body: params,
      }),
    }),
    
    getOrderTracking: builder.query({
      query: (body) => ({
        url: `/api/seller/order/track_porter_order/`,
        method: "POST",
        body: body,
      }),
    }),
   
  }),
});

export const { usePorterOrderAPIMutation, useGetOrderTrackingQuery } = PorterAPI;

export default PorterAPI;
